import { render, staticRenderFns } from "./AdminTenantNormalizedNames.vue?vue&type=template&id=7dd4069a"
import script from "./AdminTenantNormalizedNames.vue?vue&type=script&lang=js"
export * from "./AdminTenantNormalizedNames.vue?vue&type=script&lang=js"
import style0 from "./AdminTenantNormalizedNames.vue?vue&type=style&index=0&id=7dd4069a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports